module.exports = __webpack_public_path__ + "img/benefit_game-tickets.7fecc031.jpg";